import { constants, publicCall } from '../utils'
import portalConfig from '../services/portalConfig'

const baseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL

  const config = portalConfig.config()

  return config ? config.apiUrl : ''
}

// O portal não manda mais chave: o back reconhece o portal pela Origin, que o
// navegador preenche sozinho na requisição cross-origin. O primeiro argumento
// (antigo `useToken`) fica só por compatibilidade das chamadas que já existem.
const headers = (_useToken = true, overrides = {}) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json;charset=UTF-8',
  ...overrides,
})

// A chamada escolhida vai em toda requisição, num lugar só: do outro lado tudo
// pendura no current_public_call, e listar endpoint por endpoint seria mais um
// lugar para esquecer.
//
// Sem escolha guardada, a API serve a última chamada da mantenedora — que é o
// comportamento de antes. É a ponte enquanto este portal não sobe.
const withPublicCall = endpoint => {
  const id = publicCall.chosenId()

  if (!id) return endpoint

  const separator = endpoint.includes('?') ? '&' : '?'

  return `${endpoint}${separator}public_call_id=${id}`
}

const url = endpoint =>
  baseUrl() + constants.api.currentVersion + withPublicCall(endpoint)

const SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS']

const blockedResponse = message =>
  new Response(JSON.stringify({ errors: { base: [message] } }), {
    status: 409,
    headers: { 'Content-Type': 'application/json' },
  })

// unauthorizedIsAnswer: o 401 é resposta de negócio (ex.: senha errada), não
// portal recusado. Sem chave para rotacionar, um 401 que não é resposta de
// negócio significa portal não reconhecido — mostra o estado de não configurado,
// não adianta repetir a requisição.
const request = async (input, init = {}, { unauthorizedIsAnswer = false } = {}) => {
  const method = (init.method || 'GET').toUpperCase()

  if (!SAFE_METHODS.includes(method) && publicCall.switchedElsewhere()) {
    publicCall.notifySwitched()

    return blockedResponse('Você trocou de chamada em outra aba')
  }

  const response = await fetch(input, init)

  if (response.status === 401 && !unauthorizedIsAnswer) {
    portalConfig.markUnauthorized()
  }

  return response
}

const base = { headers, request, url }
export default base
